import { ApiUrls } from '@api/apiUrls';
import ENUM_TYPES from '@components-shared/enum.types';

export const apiImageUserService = {
  getImageSrc: ({
    imageUniqueId,
    clientType,
    sizeType,
  }: {
    imageUniqueId: string;
    clientType: ENUM_TYPES['IMAGE_CLIENT_TYPE'];
    sizeType: ENUM_TYPES['IMAGE_SIZE_TYPE'];
  }) => {
    return `${ApiUrls.imageUser.download}?imageUniqueId=${imageUniqueId}&clientType=${clientType}&sizeType=${sizeType}`;
  },

  getMembersAreaImageSrc: ({ imageUniqueId }: { imageUniqueId: string }) => {
    return apiImageUserService.getImageSrc({
      imageUniqueId,
      clientType: 'MembersAreaDesktop',
      sizeType: 'FullWidth',
    });
  },
};
